import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { DragAndDropListsComponent } from './drag-and-drop-lists/drag-and-drop-lists.component';

@NgModule({
  imports: [CommonModule, FormsModule, DragDropModule, MatIconModule],
  declarations: [DragAndDropListsComponent],
  exports: [DragAndDropListsComponent],
})
export class MiqDragAndDropListModule {}
